import React from "react";

import { Delete, Plus } from "icons";
import PropTypes from "prop-types";

import {
  Button,
  Typography,
  Dropdown,
  DropdownOverlay,
  Input,
  Select,
} from "clearsense-ui/components";

const Filter = ({
  count,
  title,
  filterConditions,
  setFilterConditions,
  columnOptions,
  conditionOptions,
  filterOperations,
}) => {
  const updateFilterCondition = (id, payload) => {
    setFilterConditions(prev =>
      prev.map(item => (item.id === id ? { ...item, ...payload } : item))
    );
  };

  const addFilterCondition = () => {
    let newConditions =
      filterConditions.length > 0
        ? [
            {
              type: "between",
              id: filterConditions.length + 1,
              operation: { label: "AND", value: "and" },
            },
          ]
        : [];
    const newId =
      filterConditions.length + (filterConditions.length > 0 ? 2 : 1);
    newConditions = [
      ...newConditions,
      {
        type: "condition",
        id: newId,
        column: "",
        condition: "",
        value: "",
      },
    ];
    setFilterConditions(prev => [...prev, ...newConditions]);
  };

  const deleteFilterCondition = id => {
    setFilterConditions(prev => prev.filter(item => item.id !== id));
    setFilterConditions(prev =>
      prev.filter(
        item => item.id !== id + (id === filterConditions[0].id ? 1 : -1)
      )
    );
  };
  return (
    <DropdownOverlay
      position="right"
      buttonLabel="Add Filter"
      buttonStyle="secondary"
      buttonProps={{
        icon: Plus,
        className: "text-semibold",
        disabled: !count,
      }}
      className="flex-shrink-0"
    >
      {({ onClose }) => (
        <div className="cs-ui-container__filter">
          <Typography className="font-semibold">{title}</Typography>

          {filterConditions.map(condition => (
            <div className="mt-4 mb-3" key={condition.id}>
              {condition.type === "condition" ? (
                <div className="flex items-center gap-2 p-2 bg-grey-blue dark:bg-cs-ui-gray-700">
                  <Select
                    placeholder="Column"
                    size="small"
                    options={columnOptions}
                  />
                  <Select
                    placeholder="Condition"
                    size="small"
                    options={conditionOptions}
                  />
                  <Input
                    placeholder="Enter value"
                    value={condition.value}
                    onChange={e =>
                      updateFilterCondition(condition.id, {
                        value: e.target.value,
                      })
                    }
                  />
                  <Delete
                    className="cursor-pointer text-danger"
                    onClick={() => deleteFilterCondition(condition.id)}
                  />
                </div>
              ) : (
                <div className="flex items-center gap-2 my-3">
                  <span className="flex-grow border-t border-content-light" />
                  <Dropdown
                    label={condition.operation.label}
                    buttonProps={{
                      className: "bg-shade-light text-content-darker",
                    }}
                  >
                    {filterOperations.map(operation => (
                      <li
                        key={operation.label}
                        onClick={() =>
                          updateFilterCondition(condition.id, {
                            operation,
                          })
                        }
                      >
                        {operation.label}
                      </li>
                    ))}
                  </Dropdown>
                  <span className="flex-grow border-t border-content-light" />
                </div>
              )}
            </div>
          ))}
          <Button
            label="Add condition"
            icon={Plus}
            iconPosition="left"
            style="secondary"
            onClick={addFilterCondition}
          />
          <div className="mt-4">
            <Button
              label="Done"
              disabled={!filterConditions.length}
              onClick={onClose}
            />
          </div>
        </div>
      )}
    </DropdownOverlay>
  );
};

Filter.propTypes = {
  title: PropTypes.string,
  filterConditions: PropTypes.array,
  setFilterConditions: PropTypes.func,
  columnOptions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
  conditionOptions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
  filterOperations: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
};

export default Filter;
